"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var Svg2Balconies = function Svg2Balconies(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.581 20.935c1.655-1.25 2.482-2.743 2.482-4.479 0-1.735-.372-2.996-1.117-3.781m-14.883 8.26c-1.655-1.25-2.482-2.743-2.482-4.479 0-1.735.372-2.996 1.117-3.781",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.043 11.576c-.234-.353-.524-.53-.87-.53-.517 0-.865.382-.865.884 0 .501.212.895 1.295.895h8.619",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.487 11.576c.234-.353.524-.53.869-.53.518 0 .866.382.866.884 0 .501-.212.895-1.296.895h-8.618m.645.34v6.927m-2.957-6.965c-.436 2.26-.436 4.593 0 7m-2.701-7.004c-.858 2.357-.752 4.715.318 7.072m7.729-7.068c.436 2.26.436 4.593 0 7m2.808-7.004c.858 2.357.752 4.715-.318 7.072m-9.698-8.799V2.252h9.68v9.18m-4.742-.197v-1.22",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M4 20h16v2H4z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Backpack-Bold, Backpack",
    fontSize: 8,
    fontWeight: "bold",
    fill: "#4D4D4D",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 8
  }, '2'))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(Svg2Balconies);
var _default = exports["default"] = Memo;